import { ModuleUserPermissions } from '../enums/module-user-permissions.enum';
import { IModuleManagerPermission } from '../interfaces/module-manager-permission.interface';

// @dynamic
export class ModuleManagerPermissions {
    static all: IModuleManagerPermission[] = [
        {
            title: 'PERMISSION.CONTENT_MANAGEMENT.TITLE',
            description: '',
            value: ModuleUserPermissions.module_content_management,
        },
        {
            title: 'PERMISSION.STRUCTURE_MANAGEMENT.TITLE',
            description: 'PERMISSION.STRUCTURE_MANAGEMENT.DESCRIPTION',
            value: ModuleUserPermissions.module_structure_management,
        },
        {
            title: 'PERMISSION.DISPLAY_MANAGEMENT.TITLE',
            description: 'PERMISSION.DISPLAY_MANAGEMENT.DESCRIPTION',
            value: ModuleUserPermissions.module_display_management,
        },
        {
            title: 'PERMISSION.GRADE_MANAGEMENT.TITLE',
            description: '',
            value: ModuleUserPermissions.module_grade_management,
        },
        {
            title: 'PERMISSION.EVENT_MANAGEMENT.TITLE',
            description: 'PERMISSION.EVENT_MANAGEMENT.DESCRIPTION',
            value: ModuleUserPermissions.module_event_management,
        },
        {
            title: 'PERMISSION.CERTIFICATE_MANAGEMENT.TITLE',
            description: '',
            value: ModuleUserPermissions.module_certificate_management,
        },
        {
            title: 'PERMISSION.COURSE_BOOKING_MANAGEMENT.TITLE',
            description: 'PERMISSION.COURSE_BOOKING_MANAGEMENT.DESCRIPTION',
            value: ModuleUserPermissions.course_booking_management,
        },
    ];
}
